import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


class NotificationHOC extends Component {

    notify (message,errorType) {

        if (! toast.isActive(this.toastId)) {
            if (errorType === 'error')
                this.toastId = toast.error(message);
            else if (errorType === 'warning')
                this.toastId = toast.warning(message);
            else if (errorType === 'info')
                this.toastId = toast.info(message);
            else if (errorType === 'success')
                this.toastId = toast.success(message);
            else if (errorType === 'default')
                this.toastId = toast.default(message);
        }

    }

    render(){
        return (
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnVisibilityChange
                draggable
                pauseOnHover
            />
        )
    }
}


export default NotificationHOC;


// WEBPACK FOOTER //
// ./src/components/Notifications/NotificationHOC.js